// extracted by mini-css-extract-plugin
export default {"button":"CodeInput_button__Yrr3W","input":"CodeInput_input__IS17S"};